import {
  DateTypeFilter,
  FilterPaymentType,
  getFilterDisplayDates,
  InvoiceFilterOrderType,
  InvoiceFilterStatus,
  InvoiceFilterType,
  InvoiceQuickFilterOptions,
  InvoiceSearchParams,
  PaymentType,
  RecordedValue,
} from '@frontend/api-invoices';
import { DEFAULT_INVOICE_LIST_ORDER, DEFAULT_INVOICE_SELECTED_STATUS } from './invoice-provider';

export const paidInvoiceStatuses = [InvoiceFilterStatus.paid, InvoiceFilterStatus.partiallyPaid];

/**
 * Gets the search params to use in the invoice request from the invoice filter
 * @param filter Invoice filter
 */
export const getSearchParams = (
  filter: InvoiceFilterType,
  locationIds: string[],
  order: InvoiceFilterOrderType,
  selectedStatus: InvoiceQuickFilterOptions = DEFAULT_INVOICE_SELECTED_STATUS
): InvoiceSearchParams => {
  const params: InvoiceSearchParams = {};

  if (filter.recorded) {
    params.isRecorded = filter?.recorded === RecordedValue.recorded;
  }

  if (filter.person) {
    const personText = filter.person.toLowerCase();
    if (personText.startsWith('id:')) {
      params.personid = personText.replace(/^id:/, '');
    } else {
      params.search = filter.person;
    }
  }

  if (filter.paymentType) {
    params['invoice.payment.origin'] = filter.paymentType;
  }
  if (filter.cardType) {
    params['invoice.payment.cardtype'] = filter.cardType;
  }
  if (filter.paymentMethod) {
    const paymentMethods = [
      ...filter.paymentMethod,
      ...(filter.paymentMethod.includes(FilterPaymentType.Card) ? [PaymentType.CardPresent] : []),
    ];
    params['invoice.payment.paymenttype'] = paymentMethods as PaymentType[];
  }
  if (locationIds.length) {
    params.locationIds = locationIds;
  }
  if (filter.providerName) {
    params.providername = [filter.providerName];
  }

  const [startDate, endDate] = getFilterDisplayDates(filter.dateRange);

  const isPaidList = selectedStatus === 'paid' || filter.dateType === DateTypeFilter.Paid;
  if (filter.dateType === DateTypeFilter.Created) {
    params.order = '-billedAt';
  } else {
    params.order = order || (isPaidList ? '-paidAt' : DEFAULT_INVOICE_LIST_ORDER);
  }

  if (filter.status?.length) {
    params.status = filter.status;
  } else {
    if (selectedStatus === 'paid') params.status = paidInvoiceStatuses;
    else if (selectedStatus === 'unpaid') params.status = [InvoiceFilterStatus.unpaid];
  }
  if (isPaidList) {
    params.submittedOn = {
      gte: startDate?.toISOString(),
      lte: endDate?.toISOString(),
    };
  } else if (startDate && endDate) {
    // if there is no filter set, startDate and endDate
    // will be null. So this will be the default when no
    // filter is set.
    params.start = startDate?.toISOString();
    params.end = endDate?.toISOString();
  }

  return params;
};
